// Mapbox GL Draw style definitions, extracted from MapDraw.vue so both the
// global draw control and per-tile split-screen draw controls share one source.
export const DRAW_STYLES: any[] = [
  {
    'id': 'highlight-active-points',
    'type': 'circle',
    'filter': ['all',
      ['==', '$type', 'Point'],
      ['==', 'meta', 'feature'],
      ['==', 'active', 'true']
    ],
    'paint': {
      'circle-radius': 12,
      'circle-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'circle-stroke-width': 3,
      'circle-stroke-color': '#fff',
    }
  },
  {
    'id': 'points-are-blue',
    'type': 'circle',
    'filter': ['all',
      ['==', '$type', 'Point'],
      ['==', 'meta', 'feature'],
      ['==', 'active', 'false']
    ],
    'paint': {
      'circle-radius': 10,
      'circle-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'circle-stroke-width': 3,
      'circle-stroke-color': '#fff'
    }
  },
  {
    'id': 'gl-draw-line',
    'type': 'line',
    'filter': ['all',
      ['==', '$type', 'LineString'],
      ['==', 'active', 'true']
    ],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'line-dasharray': [0.2, 2],
      'line-width': 4
    }
  },
  {
    'id': 'gl-draw-polygon-fill',
    'type': 'fill',
    'filter': ['all',
      ['==', '$type', 'Polygon'],
      ['==', 'active', 'true']
    ],
    'paint': {
      'fill-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'fill-outline-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'fill-opacity': 0.1
    }
  },
  {
    'id': 'gl-draw-polygon-stroke-active',
    'type': 'line',
    'filter': ['all',
      ['==', '$type', 'Polygon'],
      ['==', 'active', 'true']
    ],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'line-dasharray': [0.2, 2],
      'line-width': 4
    }
  },
  {
    'id': 'gl-draw-points-vertices',
    'type': 'circle',
    'filter': ['all',
      ['==', 'meta', 'vertex'],
      ['==', '$type', 'Point']
    ],
    'paint': {
      'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 8, 7],
      'circle-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'circle-stroke-width': ['case', ['==', ['get', 'active'], 'true'], 3, 2],
      'circle-stroke-color': '#fff'
    }
  },
  {
    'id': 'gl-draw-line-static',
    'type': 'line',
    'filter': ['all',
      ['==', '$type', 'LineString'],
      ['==', 'active', 'false']
    ],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'line-width': 2
    }
  },
  {
    'id': 'gl-draw-polygon-fill-static',
    'type': 'fill',
    'filter': ['all',
      ['==', '$type', 'Polygon'],
      ['==', 'active', 'false']
    ],
    'paint': {
      'fill-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'fill-outline-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'fill-opacity': 0.1
    }
  },
  {
    'id': 'gl-draw-polygon-stroke-static',
    'type': 'line',
    'filter': ['all',
      ['==', '$type', 'Polygon'],
      ['==', 'active', 'false']
    ],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color': ['case', ['has', 'user_color'], ['get', 'user_color'], '#0059ff'],
      'line-width': 2
    }
  }
]
